import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  permissions: [],
  selectedPermission: null,
};

const permissionSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    // Get Permissions
    getPermissionsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getPermissionsSuccess: (state, action) => {
      state.loading = false;
      state.permissions = action.payload;
      state.error = null;
    },
    getPermissionsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Create Permission
    createPermissionStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    createPermissionSuccess: (state, action) => {
      state.loading = false;
      state.permissions.push(action.payload);
      state.error = null;
    },
    createPermissionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Set Selected Permission
    setSelectedPermission: (state, action) => {
      state.selectedPermission = action.payload;
    },

    // Clear Error
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  getPermissionsStart,
  getPermissionsSuccess,
  getPermissionsFailure,
  createPermissionStart,
  createPermissionSuccess,
  createPermissionFailure,
  setSelectedPermission,
  clearError,
} = permissionSlice.actions;

export default permissionSlice.reducer;
